import { render, staticRenderFns } from "./textAreaItem.vue?vue&type=template&id=5576266c"
import script from "./textAreaItem.vue?vue&type=script&lang=js"
export * from "./textAreaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports